import { Joi } from 'app-webtech-core/schemas';
import { actionCreator } from 'app-webtech-core/actions/actionCreator';
import { vodContentPropertiesSelector } from '../../vodContent/selectors/properties';
import { setIsVideoRequestedAction as setIsVideoRequested } from '../../player/actions/setIsVideoRequested';
import { CHANGE_SELECTED_INDEX } from './types';

const vodGuideChangeSelectedIndexActionPayloadSchema = Joi.object().keys({
  newIndex: Joi.number().required(),
});

export const vodGuideChangeSelectedIndexAction = actionCreator(
  CHANGE_SELECTED_INDEX,
  vodGuideChangeSelectedIndexActionPayloadSchema,
);

export const vodGuideChangeSelectedIndexThunkAction = ({ newIndex }) => (dispatch, getState) => {
  const state = getState();
  const payload = { newIndex };
  const { selectedIndex } = vodContentPropertiesSelector(state);

  if (selectedIndex !== newIndex) {
    dispatch(vodGuideChangeSelectedIndexAction(payload));
    dispatch(setIsVideoRequested({ videoRequested: false }));
  }
};
